import { render, staticRenderFns } from "./permission-tree.vue?vue&type=template&id=6e2dee5a&scoped=true"
import script from "./permission-tree.vue?vue&type=script&lang=js"
export * from "./permission-tree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2dee5a",
  null
  
)

export default component.exports